module.exports = __webpack_public_path__ + "img/free_multiplier_10.1e455313.png";